import { dia } from '@joint/plus';
export var Decorator = dia.HighlighterView.extend({
    tagName: 'text',
    attributes: {
        'fill': '#5755a1',
        'font-style': 'italic',
        'font-weight': 'bold',
        'text-anchor': 'end',
        'font-size': 12
    },
    events: {
        'click': 'onClick'
    },
    onClick: function (evt) {
        var _a = this, cellView = _a.cellView, node = _a.node;
        var itemId = cellView.findAttribute('item-id', node);
        cellView.paper.trigger('element:decorator:pointerdown', cellView, evt, itemId);
    },
    options: {
        margin: 0,
        text: 'fn()'
    },
    highlight: function (cellView, node) {
        var _a = this, vel = _a.vel, options = _a.options;
        var model = cellView.model;
        var itemId = cellView.findAttribute('item-id', node);
        if (!itemId || !model.isItemVisible(itemId) || !model.isItemInView(itemId)) {
            vel.attr('display', 'none');
            return;
        }
        var margin = options.margin, text = options.text;
        var width = model.size().width;
        var padding = model.getPadding();
        var itemBBox = model.getItemBBox(itemId);
        var scroll = model.getScrollTop() || 0;
        vel.attr({
            x: width - margin,
            y: itemBBox.center().y + padding.top - scroll
        });
        vel.text(text, { textVerticalAnchor: 'middle' });
        vel.removeAttr('display');
    }
}, {
    create: function (view, itemId, opt) {
        if (opt === void 0) { opt = {}; }
        var text = opt.text, _a = opt.margin, margin = _a === void 0 ? 5 : _a;
        var id = "decorator_".concat(itemId);
        var selector = "itemBody_".concat(itemId);
        this.add(view, selector, id, {
            layer: dia.Paper.Layers.FRONT,
            margin: margin,
            text: text
        });
    }
});
